/* unplugin-vue-components disabled */import { render } from "./cards.vue?vue&type=template&id=68f61057&scoped=true"
import script from "./cards.vue?vue&type=script&lang=js"
export * from "./cards.vue?vue&type=script&lang=js"

import "./cards.vue?vue&type=style&index=0&id=68f61057&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f61057"],['__file',"src/components/cards/cards.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68f61057"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68f61057', __exports__)) {
    api.reload('68f61057', __exports__)
  }
  
  module.hot.accept("./cards.vue?vue&type=template&id=68f61057&scoped=true", () => {
    api.rerender('68f61057', render)
  })

}


export default __exports__